import request from '../utils/request';
export const LOGIN = params => request('get', '/User/Login', params, true)
export const Wx_LOGIN = () => request('get', '/User/WxLogin', true)
export const REG = params => request('post', '/User/Register', params)
export const LOGOUT = params => request('post', '/operator/logout', params)
export const Get_Member_System = params => request('get', '/User/GetMemberSystem', params, true)
export const Get_Member_System_By_Code = params => request('get', '/User/GetMemberSystemByCode', params, true)
export const Refresh_Token = params => request('get', '/User/RefreshToken', params)
export const Check_Tel = params => request('get', '/User/CheckTel', params)
export const Check_Reg_Tel = params => request('get', '/User/CheckRegTel', params)
export const Get_Brand_Tree = params => request('get', '/Brand/GetBrandTree', params)
export const Get_Brand_Node_List = params => request('get', '/Brand/GetBrandNodeList', params)
export const Get_Brand_Node = params => request('get', '/Brand/GetBrandNode', params)
export const Get_File_Node_List = params => request('get', '/Brand/GetFileNodeList', params)
export const Send_SMS_Code = params => request('get', '/SMS/SendCode', params)
export const Update_Nick_Name = params => request('get', '/User/UpdateNickName', params)
export const Update_Tel = params => request('get', '/User/UpdateTel', params)
export const To_Creator = params => request('get', '/User/ToCreator')
export const Update_Password = params => request('get', '/User/UpdatePassword', params)
export const Check_Password = params => request('post', '/User/CheckPassword', params)
export const H5Pay = params => request('get', '/User/H5/PayOrder', params)
export const JsApi = params => request('get', '/Pay/JsApi', params)
export const NativeByCodeUrl = params => request('get', '/Pay/NativeByCodeUrl', params)
export const Check_pay = params => request('get', '/Pay/CheckPay', params)
export const Check_Wx_Login = () => request('get', '/User/H5/CheckWxLogin')
export const Prepare_Wx_Config = (params) => request('get', '/User/H5/PrepareWxConfig', params)
export const H5_Wx_Code = (params) => request('get', '/User/H5/WxCode', params)


export const Get_Product_List = params => request('get', '/Product/GetProductList', params)
export const Get_The_Lastest_News = () => request('get', '/News/GetTheLastestNews')
export const Get_News_List = params => request('get', '/News/GetNewsList', params, true)
export const Wx_Bind = () => request('get', '/User/BindWx')
export const Wx_Unbind = () => request('get', '/User/UnbindWx')
export const Check_Wx_OpenID = () => request('get', '/User/CheckWxOpenID')
export const Get_Wx_OpenID = () => request('get', '/User/GetWxOpenID')
export const Add_Order = params => request('get', '/Order/AddOrder', params)
export const Check_Order_Is_Paid = params => request('get', '/Order/CheckOrderIsPaid', params)
export const Reload_User_Info = params => request('get', '/User/Reload', params)
export const Check_Expire_Date = params => request('get', '/User/CheckExpireDate', params, false)

export const Is_Expire_Tips = params => request('get', '/User/IsExpireTips')
export const Get_Case_List = params => request('get', '/Brand/GetCaseList', params)
export const Upload_File = params => request('post', '/Upload/OSS/File', params) ///Upload/File
export const Add_Case = params => request('post', '/Brand/AddCase', params)
export const Is_View_Case = params => request('get', '/Brand/IsViewCase', params)
export const Add_Case_View_Log = params => request('post', '/Brand/AddCaseViewLog', params)
export const Get_Case_View_Log_List = params => request('get', '/Brand/GetCaseViewLogList', params)
export const Search_Case_View_Log_List = params => request('get', '/Brand/SearchCaseViewLogList', params)
export const Get_Order_Item_List = params => request('get', '/Pay/GetOrderItemListByShopType', params)
export const Add_Good_Num = params => request('get', '/Brand/AddCaseZan', params)
// export const Is_Today_FileViewNum_OverLimit = params => request('get', '/Brand/IsTodayFileViewNumOverLimit', params)

//新增接口
export const Has_Case = params => request('get', '/Brand/HasCase', params)
export const Check_File_Url = params => request('get', '/Brand/CheckFileUrl', params)
